var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h1", [_vm._v("Button 组件")]),
      _vm._v(" "),
      _c("p", [_vm._v("通用按钮组件。")]),
      _vm._v(" "),
      _c("h2", [_vm._v("何时使用")]),
      _vm._v(" "),
      _c("p", [_vm._v("向页面插入一个按钮。")]),
      _vm._v(" "),
      _c("h2", [_vm._v("示例")]),
      _vm._v(" "),
      _c("p", [
        _c("img", {
          attrs: {
            src:
              "http://t1.market.xiaomi.com/download/Browser/07c90473d1e33e68991f90e8e4a9b4155144026dc",
            alt: "示例按钮截图"
          }
        })
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-html" } }, [
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("template")]),
            _vm._v(">")
          ]),
          _vm._v("\n  "),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("Button")]),
            _vm._v("\n      "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v(":loading")]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v('"loading"')
            ]),
            _vm._v("\n      "),
            _c("span", { attrs: { class: "hljs-attr" } }, [
              _vm._v(":disabled")
            ]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v('"!selectedCash"')
            ]),
            _vm._v("\n      "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("@click")]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v('"clickHandler"')
            ]),
            _vm._v(">")
          ]),
          _vm._v("立即兑换"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("Button")]),
            _vm._v(">")
          ]),
          _vm._v("\n"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("template")]),
            _vm._v(">")
          ]),
          _vm._v("\n\n"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("script")]),
            _vm._v(">")
          ]),
          _c("span", { attrs: { class: "javascript" } }, [
            _vm._v("\n"),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("import")
            ]),
            _vm._v(" Button "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
            _vm._v(" "),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v("'@/components/Button'")
            ]),
            _vm._v(";\n\n"),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("export")
            ]),
            _vm._v(" "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("default")
            ]),
            _vm._v(" {\n    "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("name")]),
            _vm._v(": "),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v("'Button'")
            ]),
            _vm._v(",\n    "),
            _c("span", { attrs: { class: "hljs-attr" } }, [
              _vm._v("components")
            ]),
            _vm._v(": {\n      Button,\n    },\n    "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("methods")]),
            _vm._v(": {\n      clickHandler() {},\n    },\n};\n")
          ]),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("script")]),
            _vm._v(">")
          ]),
          _vm._v("\n")
        ])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("API")]),
      _vm._v(" "),
      _c("p", [_vm._v("Button的属性说明如下：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("属性")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("说明")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("类型")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("required")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("默认值")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("备注")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("loading")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("是否展示loading圆圈")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("Boolean")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("false")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("false")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("disabled")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("是否为禁用状态")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("Boolean")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("false")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("false")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v(
                "设置为true时不会向父组件发送click事件，并修改按钮样式（置灰）"
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("customStyle")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("自定义样式对象，传入css样式属性")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("Object")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("false")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _c("code", { pre: true }, [_vm._v("{}")])
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [_vm._v("-")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("事件：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("名称")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("回调参数")
            ]),
            _vm._v(" "),
            _c("th", { staticStyle: { "text-align": "left" } }, [
              _vm._v("备注")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", { staticStyle: { "text-align": "left" } }, [
              _vm._v("click")
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [_vm._v("无")]),
            _vm._v(" "),
            _c("td", { staticStyle: { "text-align": "left" } }, [_vm._v("-")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib!./node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./docs/button.md?vue&type=template&id=38bcec75&
// module id = null
// module chunks = 